import {Component, forwardRef, Inject, OnInit} from '@angular/core';

import {LocalCacheService, UserService} from '@app/core';
import {EnvironmentType, Roles, RouteLink, UserType} from '@app/shared';

import {AppComponent} from '../../app.component';

@Component({
  selector: 'app-topbar',
  templateUrl: './app-topbar.component.html'
})

export class AppTopbarComponent implements OnInit {
  EnvironmentType: typeof EnvironmentType = EnvironmentType;
  Roles: typeof Roles = Roles;
  RouteLink: typeof RouteLink = RouteLink;
  UserType: typeof UserType = UserType;
  enableFeedback: boolean;

  constructor(@Inject(forwardRef(() => AppComponent)) public app: AppComponent, public user: UserService, private cache: LocalCacheService) {
  }


  ngOnInit() {

  }

  initiateConnect() {
    this.app.showConnect = true;
    this.app.connectNotification = false;
  }

  onClickEnableFeedback(event, overlayPanel) {
    console.log(event);
    overlayPanel.toggle(event);
    this.enableFeedback = true;
  }

  onClickPrintCache() {
    console.log(this.cache);
  }
}
